import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlignCenterHorizontal, AlignCenterVertical } from 'lucide-react';

import { useMediaStudio } from '../../../../context/MediaStudioContext';
import InspectorSection from '../inspector-section/InspectorSection';
import ToolButton from '../tool-button/ToolButton';
import ToolButtonGroup from '../tool-button/ToolButtonGroup';

function AlignSection({ element, elements = [element] }) {
  const { t } = useTranslation('mediaStudio');
  const { editor } = useMediaStudio();
  const align = (mode) =>
    editor.alignElement(
      elements.map((item) => item.id),
      mode,
    );

  return (
    <InspectorSection title={t('align')}>
      <ToolButtonGroup>
        <ToolButton title={t('alignCenter')} onClick={() => align('horizontal')}>
          <AlignCenterVertical size={16} />
        </ToolButton>
        <ToolButton title={t('alignMiddle')} onClick={() => align('vertical')}>
          <AlignCenterHorizontal size={16} />
        </ToolButton>
        <ToolButton title={t('alignCenterMiddle')} onClick={() => align('both')}>
          <AlignCenterHorizontal size={16} />
          <AlignCenterVertical size={16} />
        </ToolButton>
      </ToolButtonGroup>
    </InspectorSection>
  );
}

export default AlignSection;
